
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avif-speed-quality-benchmark",
      function () {
        return require("private-next-pages/avif-speed-quality-benchmark.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avif-speed-quality-benchmark"])
      });
    }
  